module.exports = __webpack_public_path__ + "static/img/zhu-ge-kong-ming-chen-tan-xiang.a3938ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/zhu-ge-kong-ming-chen-tan-xiang.jpg
// module id = XsrQ
// module chunks = 1